import { render, staticRenderFns } from "./AccessLink.vue?vue&type=template&id=e423f026&"
import script from "./AccessLink.vue?vue&type=script&lang=js&"
export * from "./AccessLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports